/**
 * contact-form.js — Contact Form Validation & AJAX Submission
 * Handles client-side validation and sends form data to submit-contact.php via fetch.
 * Works on the live Hostinger server only (PHP + MySQL backend).
 */

export function initContactForm() {
  const form = document.getElementById('contact-form');
  if (!form) return;

  const submitBtn = form.querySelector('.form-submit-btn');
  const successToast = document.getElementById('form-success-toast');
  const errorToast = document.getElementById('form-error-toast');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    // Clear previous messages
    hideToast(successToast);
    hideToast(errorToast);

    // Client-side validation
    const name = form.querySelector('#field-name').value.trim();
    const email = form.querySelector('#field-email').value.trim();
    const phone = form.querySelector('#field-phone').value.trim();

    if (!name || !email || !phone) {
      showToast(errorToast, 'Please fill in all required fields.');
      return;
    }

    if (!isValidEmail(email)) {
      showToast(errorToast, 'Please enter a valid email address.');
      return;
    }

    // Disable submit button and show loading state
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending...';
    submitBtn.classList.add('btn-loading');

    try {
      const formData = new FormData(form);

      const response = await fetch('./submit-contact.php', {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (result.status === 'success') {
        window.location.href = './thank-you.html';
      } else {
        showToast(errorToast, result.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      // This will happen during local dev (no PHP server) — show a friendly message
      showToast(errorToast, 'Could not connect to the server. Please contact us via WhatsApp instead.');
      console.warn('Form submission failed:', err);
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = '🚀 Send Message';
      submitBtn.classList.remove('btn-loading');
    }
  });
}

function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function showToast(el, message) {
  if (!el) return;
  el.querySelector('.toast-message').textContent = message;
  el.classList.add('toast-visible');
}

function hideToast(el) {
  if (!el) return;
  el.classList.remove('toast-visible');
}
